import moment from "moment";
import { dateFormat } from "../../src/components/DateSelector/dateSelector.constant";

export const currentDate = (): moment.Moment =>
  moment().subtract(0, "week").endOf("day");

export const currentDateStr = (): string => currentDate().format(dateFormat);
